import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { CmsModule } from '@fcom/cms/components/cms.module';
import { PipesModule } from '@fcom/common/pipes/pipes.module';
import { UiComponentsModule } from '@fcom/ui-components/ui-components.module';
import { UiTranslateModule } from '@fcom/ui-translate/ui-translate.module';

import { KidsInBusinessNotificationComponent } from './kids-in-business-notification.component';

@NgModule({
  imports: [CommonModule, PipesModule, UiTranslateModule, UiComponentsModule, CmsModule],
  declarations: [KidsInBusinessNotificationComponent],
  exports: [KidsInBusinessNotificationComponent],
})
export class KidsInBusinessNotificationModule {}
